module.exports = __webpack_public_path__ + "static/img/logo.500a721c.svg";